import * as Dialog from 'devextreme/ui/dialog';
import * as DocumentIdConstants from 'data/documentIdConstant';
import * as HomePageErrorCodes from 'pages/Home/data/errorCode';
import * as LocalStorage from './localStorage';
import { pageNames, pagePaths } from './routes';
import * as RoutesUtils from './routesUtils';
import * as SessionStorage from './sessionStorage';

export function getData(url) {
    return request(url)
        .then(handleResponse)
        .then((response) => response.json());
}

export function postData(url, data) {
    return request(url, {
        method: 'POST',
        body: JSON.stringify(data)
    }).then(handleResponse);
}

export function putData(url, data) {
    return request(url, {
        method: 'PUT',
        body: JSON.stringify(data)
    }).then(handleResponse);
}

export function deleteData(url) {
    return request(url, {
        method: 'DELETE'
    }).then(handleResponse);
}

export function buildUrl(path, parameters) {
    const accountBookId = SessionStorage.getAccountBookId() || 0;
    let url = `/api/${accountBookId}/${path}`;

    if (parameters) {
        let queryString = '';

        for (const prop in parameters) {
            const propValue = parameters[prop];

            if (propValue !== null && propValue !== undefined) {
                if (Array.isArray(propValue)) {
                    for (let i = 0; i < propValue.length; i++) {
                        queryString += `${queryString ? '&' : '?'}${prop}=${encodeURIComponent(propValue[i])}`;
                    }
                } else {
                    queryString += `${queryString ? '&' : '?'}${prop}=${encodeURIComponent(propValue)}`;
                }
            }
        }

        url += queryString;
    }

    return url;
}

function request(url, options) {
    const fetchOptions = {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            'X-TABLE-SESSION-ID': SessionStorage.getTableSessionId(),
            'X-USER-ID': LocalStorage.getUserId(),
            'X-SHARE-CART': SessionStorage.getShareCart()
        }
    };

    return fetch(url, fetchOptions);
}

function handleResponse(response) {
    if (response.headers) {
        const version = response.headers.get('x-app-version');

        if (version) {
            window.GLOBAL_Version = version;
        }
    }

    if (response.ok) {
        return response;
    } else {
        return response
            .json()
            .then((data) => {
                const { isAccessDenied, isSessionClosed, isRestaurantClosed, message } = data;

                if (isAccessDenied) {
                    RoutesUtils.redirectToPageByPath(pagePaths.QRCodeInvalid);
                } else if (isSessionClosed || isRestaurantClosed) {
                    const messageHtml = `
                        <div id="${DocumentIdConstants.DevExtremeUIDialog}" style="max-width:500px">
                            Please click Reload button below to reload.
                        </div>
                    `;

                    const options = {
                        errorCode: isSessionClosed
                            ? HomePageErrorCodes.SessionClosed
                            : HomePageErrorCodes.RestaurantClosed
                    };

                    const dialog = Dialog.custom({
                        showTitle: true,
                        title: message,
                        dragEnabled: false,
                        messageHtml,
                        buttons: [
                            {
                                text: 'Reload',
                                type: 'default',
                                onClick: () => RoutesUtils.redirectToPageByName(pageNames.Home, options)
                            }
                        ]
                    });

                    dialog.show();
                }

                throw new ApiException(response.status, message);
            })
            .catch((error) => {
                if (error.status) throw error;
                else throw new ApiException(response.status);
            });
    }
}

function ApiException(status, message) {
    this.status = status;
    this.message = message ? message : `Request failed with status ${status}`;
}

ApiException.prototype.toString = function () {
    return this.message;
};
